// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#summaryContainer {
    display: grid;
    grid-template-columns: 40% 1fr;
    column-gap: 20px;
}

@media (max-width: 600px) 
{ 

    #summaryContainer {
        display: grid;
        grid-template-columns: 1fr;
        column-gap: 20px;
    }
}


#basicParcelInfo h2 {
    margin-top: 0;
}

#summaryImage {
    max-width: 100%;
    width: 100%;
}

#summaryContainer span {
    display: block;
    width: 100%;
    text-align: center;
}

#summaryContainer table th {
    text-align: start;
}


#summaryModalContent {
    display: flex;
    flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/css/summary.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;;;IAGI;QACI,aAAa;QACb,0BAA0B;QAC1B,gBAAgB;IACpB;AACJ;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":["#summaryContainer {\r\n    display: grid;\r\n    grid-template-columns: 40% 1fr;\r\n    column-gap: 20px;\r\n}\r\n\r\n@media (max-width: 600px) \r\n{ \r\n\r\n    #summaryContainer {\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n        column-gap: 20px;\r\n    }\r\n}\r\n\r\n\r\n#basicParcelInfo h2 {\r\n    margin-top: 0;\r\n}\r\n\r\n#summaryImage {\r\n    max-width: 100%;\r\n    width: 100%;\r\n}\r\n\r\n#summaryContainer span {\r\n    display: block;\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n\r\n#summaryContainer table th {\r\n    text-align: start;\r\n}\r\n\r\n\r\n#summaryModalContent {\r\n    display: flex;\r\n    flex-direction: column;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
